import { AppContext } from './AppContext';
import { useContext } from 'react';

export const useTheme = () => {
  const context = useContext(AppContext);
  return context.theme;
};
